import { render, staticRenderFns } from "./posWarnChart.vue?vue&type=template&id=5a63e6f4&scoped=true&"
import script from "./posWarnChart.vue?vue&type=script&lang=js&"
export * from "./posWarnChart.vue?vue&type=script&lang=js&"
import style0 from "./posWarnChart.vue?vue&type=style&index=0&id=5a63e6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63e6f4",
  null
  
)

export default component.exports